export default "__VITE_ASSET__BGNve91A__"